export type SupervisorSummary = {
  /** The first supervisor's name, or "" when there are none. */
  name: string;
  /** How many supervisors beyond the first. */
  othersCount: number;
};

/**
 * A schedule can have several supervisors, but the calendar card has room for
 * one name. Show the first and say how many others there are, rather than
 * silently pretending the rest do not exist.
 */
/** Only the parts of a person this needs, so any shape carrying a name fits. */
type NamedPerson = { firstName?: string | null; lastName?: string | null };

export const summariseSupervisors = (
  supervisors?: NamedPerson[] | null
): SupervisorSummary => {
  const [first, ...others] = supervisors ?? [];

  if (!first) {
    return { name: "", othersCount: 0 };
  }

  return {
    name: [first.firstName, first.lastName].filter(Boolean).join(" "),
    othersCount: others.length,
  };
};
